<template>
  <van-cell
    :title="title"
    :placeholder="placeholder"
    is-link
    :value="timeValue"
    @click="showPopup"
    required
    :label="isRequired ? label : ''"
  />
  <van-popup v-model:show="show" position="bottom">
    <van-datetime-picker
      v-model="time"
      :type="type"
      :title="label"
      :min-date="minDateVal"
      :max-date="maxDateVal"
      :formatter="formatter"
      @confirm="confirmPicker"
      @cancel="showPopup"
    />
  </van-popup>
</template>
<script>
import { reactive, toRefs, onMounted, watch, computed } from "vue";
export default {
  name: "DatePicker",
  props: {
    title: {
      type: String,
      default: "日期",
    },
    label: {
      type: String,
      default: "请选择"
    },
    // date、year-month、month-day、datehour、datetime
    type: {
      type: String,
      default: "date",
    },
    isShowPopup: {
      type: Boolean,
    },
    placeholder: {
      type: String,
      default: "请选择日期",
    },
    callback: {
      type: Function,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    // 用于回显的值
    value: {
      type: Number,
    },
    maxDate: {
      type: [Date, String],
      // default: new Date(2122, 11, 12),
      default: () => new Date(2025, 11, 31),
    },
    minDate: {
      type: [Date, String],
      default: () => new Date(1939, 11, 31),
    },
  },
  setup(props) {
    const state = reactive({
      show: false,
      time: new Date(),
      timeValue: props.label,
      // maxDate: new Date(2025, 12, 31),
      isFlag: true,
    });
    const minDateVal = computed(() => {
      if (props.minDate instanceof Date) return props.minDate;
      if (typeof props.minDate === "string") {
        return new Date(props.minDate);
      }
      return new Date(1939, 11, 31);
    });
    const maxDateVal = computed(() => {
      if (props.maxDate instanceof Date) return props.maxDate;
      if (typeof props.maxDate === "string") {
        return new Date(props.maxDate);
      }
      return new Date(2025, 11, 31);
    });
    onMounted(() => {
      if (props.value) {
        let val = Number(props.value);
        if (val && val.toString().length === 9) {
          val = val * 1000;
        } else if (val && val.toString().length === 10) {
          val = val * 1000;
        }
        state.time = new Date(val);
        formatTime(val);
      }
    });
    watch(() => props.value, (value) => {
      if (state.isFlag && value) {
        let val = Number(value);
        if (val && val.toString().length === 9) {
          val = val * 1000;
        } else if (val && val.toString().length === 10) {
          val = val * 1000;
        }
        state.time = new Date(val);
        formatTime(val);
      }
    });
    const formatTime = (val) => {
      const { type } = props;
      let timeVal = Number(val);
      if (timeVal && timeVal.toString().length === 9) {
        timeVal = timeVal * 1000;
      } else if (timeVal && timeVal.toString().length === 10) {
        timeVal = timeVal * 1000;
      }
      let date = new Date(timeVal);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let hour = date.getHours();
      let minute = date.getMinutes();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      if (hour >= 0 && hour <= 9) {
        hour = `0${hour}`;
      }
      if (minute >= 0 && minute <= 9) {
        minute = `0${minute}`;
      }
      // date、year-month、month-day、datehour
      if (type == "date") {
        state.timeValue = `${year}-${month}-${day}`;
      }
      if (type == "year-month") {
        state.timeValue = `${year}-${month}`;
      }
      if (type == "month-day") {
        state.timeValue = `${month}-${day}`;
      }
      if (type == "datehour") {
        state.timeValue = `${year}-${month}-${day} ${hour}`;
      }
      if (type == "datetime") {
        state.timeValue = `${year}-${month}-${day} ${hour}:${minute}`;
      }
    };
    // 确认选择的时间
    const confirmPicker = (val) => {
      const { type, callback } = props;
      let year = val.getFullYear();
      let month = val.getMonth() + 1;
      let day = val.getDate();
      let hour = val.getHours();
      let minute = val.getMinutes();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      if (hour >= 0 && hour <= 9) {
        hour = `0${hour}`;
      }
      if (minute >= 0 && minute <= 9) {
        minute = `0${minute}`;
      }
      // date、year-month、month-day、datehour
      if (type == "date") {
        state.timeValue = `${year}-${month}-${day}`;
      }
      if (type == "year-month") {
        state.timeValue = `${year}-${month}`;
      }
      if (type == "month-day") {
        state.timeValue = `${month}-${day}`;
      }
      if (type == "datehour") {
        state.timeValue = `${year}-${month}-${day} ${hour}`;
      }
      if (type == "datetime") {
        state.timeValue = `${year}-${month}-${day} ${hour}:${minute}`;
      }
      // console.log('timeValue', state.timeValue)
      state.isFlag = false;
      callback && callback(new Date(val).getTime() / 1000);

      showPopup();
    };
    // 选项格式化函数
    const formatter = (type, value) => {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      } else if (type === "day") {
        return `${value}日`;
      } else if (type === "hour") {
        return `${value}时`;
      } else if (type === "minute") {
        return `${value}分`;
      } else if (type === "second") {
        return `${value}秒`;
      }
      return value;
    };
    const showPopup = () => {
      state.show = !state.show;
    };
    return {
      ...toRefs(state),
      showPopup,
      formatter,
      confirmPicker,
      minDateVal,
      maxDateVal,
    };
  },
};
</script>
<style lang="less" scoped>
:deep(.van-cell__label) {
  color: #ee0a24;
}
</style>
